import React, { useEffect, useState } from 'react'
import Axios from 'axios'
import Chart from '../chart'
import Table from '../table'
import DataLayout from '../data-layout'

const SpendingByDeptNo = ({
  match: {
    params: { year, deptNo }
  },
  location
}) => {
  const [data, setData] = useState([])

  useEffect(() => {
    const loadData = async () => {
      const result = await Axios.get(`/GetDepartmentSpending/${year}/${deptNo}`)
      const _data = result.data.map(d => ({
        name: d.OrgName.trim(),
        nameClick: `/department/${year}/${deptNo}/${d.CharCode.trim()}${
          location.search
        }&charDesc=${d.OrgName.trim()}`,
        data: d.CurrentYearActual
      }))
      setData(_data.sort((a, b) => b.data - a.data))
    }

    loadData()
  }, [deptNo, location.search, year])

  return (
    <DataLayout year={year}>
      <Chart data={data} />
      <Table
        data={{
          headers: [
            {
              title: 'Category',
              dataKey: 'name',
              clickThrough: 'nameClick'
            },
            {
              title: 'Amount',
              dataKey: 'data'
            }
          ],
          data
        }}
      />
    </DataLayout>
  )
}

export default SpendingByDeptNo
